import React from 'react';
import { EnvironmentDayCelebrationkg2026 } from '../views';



const CareerOpeningPage = () => {
  return <EnvironmentDayCelebrationkg2026 />;
};

export default CareerOpeningPage;
